import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CmsRecommendedProductsComponent, Product } from '@kion/data-models';
import { Observable, Subject } from 'rxjs';
import { ProductsFacade } from '@kion/data-access/data-access-products';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink';

@Component({
  selector: 'kion-cms-product-slider',
  templateUrl: './product-slider.component.html',
  styleUrls: ['./product-slider.component.scss']
})
export class ProductSliderComponent implements OnInit, OnDestroy {

  @Input() component: CmsRecommendedProductsComponent;

  products$: Observable<Product[]>;
  productId$: Observable<string>;

  private subSink: SubSink;

  hasProduct$: Subject<boolean> = new Subject<boolean>();

  constructor(private productsFacade: ProductsFacade) {
    this.subSink = new SubSink();
  }

  ngOnInit(): void {
    const productIds = this.component?.products?.split(' ');
    this.productsFacade.loadByIds(productIds);
    if (this.component.typeCode !== 'KionReferenceProductSliderComponent') {
      this.products$ = this.productsFacade.all$.pipe(
        map(
          (products: Product[]) => products.filter(
            (product: Product) => productIds?.find(id => id === product.id) !== undefined
          ).sort(
            (a,b) => {
              const indexA = productIds.indexOf(a.id);
              const indexB = productIds.indexOf(b.id);
              return indexA < indexB ? -1 : 1;
            }
          )
        )
      );
    }
    if (this.component.typeCode === 'KionReferenceProductSliderComponent') {
      this.productId$ = this.productsFacade.activeProductId$;
      this.subSink.sink = this.productId$.subscribe(
        productId => {
          if(productId) {
            this.productsFacade.loadReferences(productId, this.component.referenceType.split(' '))
          }
        }
      );
      this.products$ = this.productsFacade.references$;
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
